module.exports = __webpack_public_path__ + "img/app_qr_my.b7f9bf10.png";